module.exports = "/assets/data/ea49acd38782ae059c555bf79e175f6e-KT7.data.json";